// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import TrailItems from './TrailItems';
import apiService from '../../../../services.js/apiService';
import { TrailItemType, Url } from '../../../../common/constants';

const PostTrailItems = ({ match }) => {
  const { pageId, trailId } = match.params;

  return (
    <TrailItems
      match={match}
      type={TrailItemType.Post}
      linkedIdKey="postId"
      linkPathGen={(id) => Url.Post.replace(':pageId', pageId).replace(':postId', id)}
      onUpdateService={(postIds) => apiService.updatePostTrailItems(pageId, trailId, { postIds })}
      onFetchTableData={(params) => apiService.getTrailItems(pageId, trailId, params)}
      onFetchLeftTransferList={(params) => apiService.getPostsByParamsForPage(params, pageId)}
      onFetchRightTransferList={() => apiService.getTrailItems(pageId, trailId, { type: TrailItemType.Post })}
    />
  );
};

PostTrailItems.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default PostTrailItems;
